import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const getHighlightedText = (searchText, initialText) => {
  const regex = new RegExp(searchText, 'gi');
  initialText = initialText.replace(/(<mark class="highlight-word">|<\/mark>)/gim, '');
  return initialText.replace(regex, '<mark class="highlight-word">$&</mark>');
};

const SearchItem = ({ item, index, searchWord, title, subTitle = null, focusedIndex }) => {
  const shouldRenderCategory = !!title;
  const shouldRenderName = !!subTitle;
  const tags = item?.item?.offerCategories?.targetItems;

  return (
    <a
      className={clsx(
        'searchItem global-search-item flex-it flex-align-item-center',
        index === focusedIndex ? 'focused' : ''
      )}
      href={item?.item?.url}
    >
      <span className="auto">
        {shouldRenderCategory && (
          <RichText
            className={clsx('title')}
            field={{
              value: getHighlightedText(searchWord, title),
            }}
          />
        )}

        {shouldRenderName && tags === (null || undefined) && (
          <RichText className="subtitle" field={subTitle} />
        )}

        {tags !== null &&
          tags?.map((tag, index) => {
            const shouldRenderName = !!tag?.name;
            if (shouldRenderName === '') {
              return null;
            }
            return (
              <div className="subtitle-wrap flex-inline" key={index}>
                <div className="subtitle">{tag?.name}</div>
              </div>
            );
          })}
      </span>
    </a>
  );
};

export default SearchItem;
